import { render, staticRenderFns } from "./DocForm.vue?vue&type=template&id=b128a07e&"
import script from "./DocForm.vue?vue&type=script&lang=js&"
export * from "./DocForm.vue?vue&type=script&lang=js&"
import style0 from "./DocForm.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports